module.exports = __webpack_public_path__ + "media/images/brands/bitbucket-76b6529966bdbafa60debd01d588f4d9.png";